import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";
import TextView from "./TextView";
import IconButton from "./IconButton";
import { BuildContext } from "../classes/BuildContext";
import ToolTipWrapper from "./ToolTipWrapper";

type _IconWithCountOnPressed = () => void;

export interface IconWithCountProps extends BaseUIProps {
  key?: string;
  icon: ui.IconData;
  count?: string;
  countBgColor?: ui.Color;
  onPressed?: _IconWithCountOnPressed;
}

class _IconWithCountState extends ObservableComponent<IconWithCountProps> {
  static defaultProps = {
    icon: null,
    count: "",
    countBgColor: null,
    onPressed: null,
  };
  static contextType = BuildContext;
  context: React.ContextType<typeof BuildContext>;
  public constructor(props: IconWithCountProps) {
    super(props);

    this.initState();
  }
  public get icon(): ui.IconData {
    return this.props.icon;
  }
  public get count(): string {
    return this.props.count;
  }
  public get countBgColor(): ui.Color {
    return this.props.countBgColor;
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.on(["count", "countBgColor", "icon"], this.rebuild);
  }
  public componentDidUpdate(prevProps: IconWithCountProps): void {
    super.componentDidUpdate(prevProps);

    if (prevProps.icon !== this.props.icon) {
      this.fire("icon", this);
    }

    if (prevProps.count !== this.props.count) {
      this.fire("count", this);
    }

    if (prevProps.countBgColor !== this.props.countBgColor) {
      this.fire("countBgColor", this);
    }
  }
  public render(): ReactNode {
    let cStyle = this.context.theme;

    return ui.Column({
      children: [
        ToolTipWrapper({
          message: "Notifications",
          backgroundColor: cStyle.tooltipBackgroundColor,
          textColor: cStyle.tooltipTextColor,
          child: ui.Stack({
            alignment: ui.AlignmentDirectional.topCenter,
            children: [
              IconButton({
                icon: this.icon,
                color: cStyle.c19,
                size: 32,
                hoverColor: cStyle.c20,
                onPressed: () => {
                  this.onIconButtonPressed();
                },
                key: "0",
              }),
              this.count !== "0"
                ? ui.Positioned({
                    child: ui.Container({
                      decoration: new ui.BoxDecoration({
                        color:
                          this.countBgColor !== null
                            ? this.countBgColor
                            : ui.HexColor.fromHexInt(0xff4ce699),
                        borderRadius: ui.BorderRadius.circular(10.0),
                      }),
                      child: TextView({
                        data: this.count,
                        textAlign: ui.TextAlign.center,
                        style: new ui.TextStyle({ color: cStyle.c21 }),
                        className: "x703 hc vc",
                      }),
                      className: "x984 hc vc",
                    }),
                    width: 20,
                    height: 20,
                    top: 0,
                    left: 5,
                  })
                : [],
            ],
            onTap: (e) => {
              e.stopPropagation();

              this.onEditHandler();
            },
            className: "x351",
            key: "0",
          }),
        }),
      ],
      className: ui.join(this.props.className, "IconWithCount"),
      ...copyBaseUIProps(this.props),
    });
  }
  public onEditHandler = (): void => {
    this.onPressed();
  };
  public onIconButtonPressed = (): void => {
    this.onPressed();
  };
  public get onPressed(): _IconWithCountOnPressed {
    return this.props.onPressed;
  }
}
export default function IconWithCount(props: IconWithCountProps) {
  return React.createElement(_IconWithCountState, {
    ..._IconWithCountState.defaultProps,
    ...props,
  });
}
